export const features = {
  powerpoint: 'POWERPOINT',
}